import type { PrimitiveKeyInterface } from '@zaoblako/shared/common/interfaces/primitive-key.interface';
import type { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';

/** Global service object which contains all SerDe DTOs */
export class SerdeDtoRegistryClass {
  private static instance: SerdeDtoRegistryClass = null;

  public static getInstance(): SerdeDtoRegistryClass {
    if (!SerdeDtoRegistryClass.instance) {
      SerdeDtoRegistryClass.instance = new SerdeDtoRegistryClass();
    }
    return SerdeDtoRegistryClass.instance;
  }

  private readonly dtos = new Map<PrimitiveKeyInterface, SerdeDtoClass<any>>();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  /**
   * Add DTO to registry. If another DTO with received key exists then it will be replaced.
   *
   * @param key DTO unique key
   * @param dto DTO
   */
  public addDto(key: PrimitiveKeyInterface, dto: SerdeDtoClass<any>): void {
    this.dtos.set(key, dto);
  }

  /**
   * Is there a DTO with the received key in the registry?
   *
   * @param key DTO unique key
   *
   * @returns Check result (`true` - exists, `false - not exists)
   */
  public hasDto(key: PrimitiveKeyInterface): boolean {
    return this.dtos.has(key);
  }

  /**
   * Get DTO by key
   *
   * @param key DTO unique key
   *
   * @returns DTO or `undefined` if DTO not found
   */
  public getDto<T>(key: PrimitiveKeyInterface): SerdeDtoClass<T> {
    return this.dtos.get(key);
  }

  /** Get iterable object with all registry DTOs */
  public getDtos(): IterableIterator<SerdeDtoClass<any>> {
    return this.dtos.values();
  }
}
